export type SupervisorsTranslation = {
  dialog: {
    cancel: string;
    create: string;
    edit: string;
    save: string;
    titleCreate: string;
    titleEdit: string;
  };
  emailTaken: string;
  fields: {
    active: string;
    companyName: string;
    email: string;
    firstName: string;
    lastName: string;
    phone: string;
  };
  status: { active: string; inactive: string };
  table: {
    add: string;
    search: string;
  };
};

export const supervisorsTranslation: SupervisorsTranslation = {
  dialog: {
    cancel: 'Anuluj',
    create: 'Dodaj',
    edit: 'Edytuj',
    save: 'Zapisz',
    titleCreate: 'Nowy opiekun',
    titleEdit: 'Edycja opiekuna',
  },
  emailTaken: 'Ten adres e-mail jest już używany.',
  fields: {
    active: 'Status aktywny',
    companyName: 'Firma',
    email: 'E-mail',
    firstName: 'Imię',
    lastName: 'Nazwisko',
    phone: 'Telefon',
  },
  status: { active: 'Aktywny', inactive: 'Nieaktywny' },
  table: {
    add: 'Dodaj opiekuna',
    search: 'Wyszukaj opiekuna',
  },
};
